import React, { Component } from "react";

export default class Toggle_button extends Component {
  state = {
    open: this.props.data_open,
  };
  componentDidUpdate = (prevprops) => {
    if (prevprops.data_open !== this.props.data_open)
      this.setState({ open: this.props.data_open });
  };
  render() {
    return (
      <div className="toggle-btn-container">
        <div
          className="toggle-btn-rapper"
          data-open={this.state.open?.toString()}
        >
          <input
            type="checkbox"
            {...this.props}
            data_open={false}
            checked={this.state.open}
            onChange={() => {
              const open = !this.state.open;
              this.setState({ open });
              if (this.props.OnChange) {
                this.props.OnChange(open);
              }
            }}
          />
        </div>
        {this.props.label ? <p className="label">{this.props.label}</p> : ""}
      </div>
    );
  }
}
